<template>
    <section class="orgRelationContainer">
        <section class="RelationSection">
            <div class="title"><strong>上级组织</strong><el-button type="primary" size="small" @click="addParentPop">添加上级</el-button></div>
            <el-table :data="getParentListTable" style="width:100%">
                <el-table-column prop="orgName" label="组织名称"  width="180"></el-table-column>
                <el-table-column prop="unifySocialCreditCode" label="统一社会信用代码"  width=""></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button @click="removeRelation(scope.row)" type="text" size="small">解除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <section class="RelationSection">
            <div class="title"><strong>下级组织</strong></div>
            <el-table :data="getChildListTable" style="width:100%">
                <el-table-column prop="orgName" label="组织名称"  width="180"></el-table-column>
                <el-table-column prop="unifySocialCreditCode" label="统一社会信用代码"  width=""></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button @click="removeRelation(scope.row)" type="text" size="small">解除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <orgRelationDialog :showdialog.sync="showdialog" @refurlist="refurlist" ref="popChildren"></orgRelationDialog>
    </section>
</template>
<script>
import orgRelationDialog from './orgRelationDialog'
export default {
    data(){
        return{
          getParentListTable:[],
          getChildListTable:[],
          showdialog:false
        }
    },
    components:{
        orgRelationDialog
    },
    mounted(){
      this.getParentList()
      this.getChildList()
    },
    methods:{
        getParentList(){
            let domainid=this.$route.query.domainid
            this.$api.getParentListApi(domainid,{
                onSucess:(resp)=>{
                    console.log(resp)
                    if(resp.data.data){
                      this.getParentListTable=resp.data.data
                    }
                }
            })
        },
        removeRelation(row){
           let domainid=this.$route.query.domainid
            this.$api.removeRelationApi(domainid,row,{
                onSucess:(resp)=>{
                    console.log(resp)
                    if(resp.status==200){
                      this.getParentList()
                      this.getChildList()
                    }
                }
            })
        },
        getChildList(){
            let domainid=this.$route.query.domainid
            this.$api.getChildListApi(domainid,{
                onSucess:(resp)=>{
                    console.log(resp)
                    if(resp.data.data){
                      this.getChildListTable=resp.data.data
                    }
                }
            })
        },
        addParentPop(){
          this.showdialog=true
        },
        refurlist(){//弹窗后刷新列表
           this.getParentList()
           this.getChildList()
        }
    }
}
</script>
<style lang="scss">
.orgRelationContainer{
  margin-top:20px;  
  .RelationSection{
      display: flex;
      flex-direction: column;
      margin-bottom: 50px;
      .title{
          display: flex;
          align-items: center;
          strong{
              font-size: 14px;
              font-weight: normal;
              margin-right:20px;
          }
      }
  }
}    
</style>